import gsap from "gsap"
import ScrollToPlugin from "gsap/ScrollToPlugin"
import { module as BaseModule } from "modujs"
import { DOMAnimations } from "../utils/dom"

gsap.registerPlugin(ScrollToPlugin)

export default class extends BaseModule {
  init() {
    this.dataButton = this.el.querySelector("[data-project-data]")
    this.textButton = this.el.querySelector("[data-project-text]")
    this.dataSection = document.getElementById("data")
    this.textSection = document.getElementById("text")

    // Track active section
    this.activeSection = null

    // Bind events
    this.bindEvents()
  }

  bindEvents() {
    // Data button click handler
    this.dataButton.addEventListener("click", () => {
      this.toggleSection(
        this.dataSection,
        this.textSection,
        this.dataButton,
        this.textButton
      )
    })

    // Text button click handler
    this.textButton.addEventListener("click", () => {
      this.toggleSection(
        this.textSection,
        this.dataSection,
        this.textButton,
        this.dataButton
      )
    })
  }

  /**
   * Toggle between sections
   * @param {HTMLElement} sectionToToggle - Section to toggle visibility
   * @param {HTMLElement} otherSection - Section to close if open
   * @param {HTMLElement} activeButton - Button of section being toggled
   * @param {HTMLElement} otherButton - Button of other section
   */
  async toggleSection(
    sectionToToggle,
    otherSection,
    activeButton,
    otherButton
  ) {
    // If the section we're toggling is already active, just close it
    if (this.activeSection === sectionToToggle) {
      await DOMAnimations.slideUp(sectionToToggle, 500)
      this.activeSection = null
      activeButton.classList.remove("active")
      return
    }

    // If the other section is open, close it first
    if (this.activeSection) {
      await DOMAnimations.slideUp(this.activeSection, 500)
      otherButton.classList.remove("active")
    }

    // Open the requested section
    activeButton.classList.add("active")
    otherButton.classList.remove("active")

    // Show the section
    await DOMAnimations.slideDown(sectionToToggle, 500)
    this.activeSection = sectionToToggle

    // Scroll to the section
    this.scrollToSection(sectionToToggle)
  }

  /**
   * Scroll to a section using GSAP
   * @param {HTMLElement} section - Section to scroll to
   */
  scrollToSection(section) {
    gsap.to(window, {
      duration: 0.8,
      scrollTo: {
        y: "#" + section.id,
        autoKill: true,
      },
      ease: "power2.inOut",
    })
  }
}
